import { getKubitPillRegularStyles } from './styles/regular';
import { getKubitPillRoundedStyles } from './styles/rounded';
import { getKubitPillSegmentedControlStyles } from './styles/segmentedControl';
import { KubitPillVariantType } from './variants';
export const getKubitPillStyles = (FOUNDATIONS, FONT) => {
    return {
        [KubitPillVariantType.REGULAR]: getKubitPillRegularStyles(FOUNDATIONS, FONT),
        [KubitPillVariantType.ROUNDED]: getKubitPillRoundedStyles(FOUNDATIONS, FONT),
        [KubitPillVariantType.SEGMENTED_CONTROL]: getKubitPillSegmentedControlStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map